export type FilterTypes = {
  vehicleType: string;
  usedInventoryType: string;
  availableInMonths: number;
  modelFamily: string[];
  bodyType: string[];
  price: number[];
  modelYear: string[];
  mileage: number[];
  power: number[];
  gearBox: string[];
  drivetrain: string[];
  fuelType: string[];
  wheelSize: string[];
  exteriorColor: string[];
  trimLine: string[];
  interiorColor: string[];
  partnerDealers: string[];
  otherMakes: string[];
  nonAudiModels: string[];
  nonAudi: string;
  // [key: string]: string | number | string[] | number[];
};

export type ExposedFiltersTypes = {
  [key: string]: boolean;
};

export type FiltersPositionTypes = {
  [key: string]: number;
};

export const INTIAL_FILTERS = {
  vehicleType: 'new',
  usedInventoryType: 'has-warranties.all',
  availableInMonths: 0,
  modelFamily: [],
  bodyType: [],
  price: [],
  modelYear: [],
  mileage: [],
  power: [],
  gearBox: [],
  drivetrain: [],
  fuelType: [],
  wheelSize: [],
  exteriorColor: [],
  trimLine: [],
  interiorColor: [],
  partnerDealers: [],
  otherMakes: [],
  nonAudiModels: [],
  nonAudi: 'foreign-brand.no',
};

export const NEW_VEHICLE_FILTERS_LIST = [
  'vehicleType',
  'bodyType',
  'modelFamily',
  'trimLine',
  'modelYear',
  'exteriorColor',
  'interiorColor',
  'price',
  'fuelType',
  'drivetrain',
  'wheelSize',
  'gearBox',
  // 'power',
];

export const USED_VEHICLE_FILTERS_LIST = [
  'vehicleType',
  'bodyType',
  'modelFamily',
  'trimLine',
  'modelYear',
  'mileage',
  'exteriorColor',
  'interiorColor',
  'price',
  'fuelType',
  'drivetrain',
  'wheelSize',
  'gearBox',
  // 'power',
];

export const NEW_VEHICLE_FILTERS_LIST_TIER_3 = [
  'vehicleType',
  'partnerDealers',
  'bodyType',
  'modelFamily',
  'trimLine',
  'modelYear',
  'exteriorColor',
  'interiorColor',
  'price',
  'fuelType',
  'drivetrain',
  'wheelSize',
  'gearBox',
  // 'power',
];

export const USED_VEHICLE_FILTERS_LIST_TIER_3 = [
  'vehicleType',
  'partnerDealers',
  'otherMakes',
  'nonAudiModels',
  'bodyType',
  'modelFamily',
  'trimLine',
  'modelYear',
  'mileage',
  'exteriorColor',
  'interiorColor',
  'price',
  'fuelType',
  'drivetrain',
  'wheelSize',
  'gearBox',
  // 'power',
];

export const USED_COMBINED_FILTERS_LIST_TIER_3 = [
  'vehicleType',
  'partnerDealers',
  'otherMakes',
  'nonAudiModels',
  // 'bodyType',
  // 'modelFamily',
  // 'trimLine',
  'modelYear',
  'mileage',
  // 'exteriorColor',
  // 'interiorColor',
  'price',
  // 'fuelType',
  // 'drivetrain',
  // 'wheelSize',
  // 'gearBox',
  // 'power',
];

export const filtersTypesToRenderWithTypeName = [
  'exteriorColor',
  'interiorColor',
  'wheelSize',
  'price',
  'power',
  'mileage',
  'availableInMonths',
  'otherMakes',
  'nonAudiModels',
];

export const REGULAR_FILTERS = [
  'bodyType',
  'drivetrain',
  'exteriorColor',
  'fuelType',
  'gearBox',
  'interiorColor',
  'modelFamily',
  'trimLine',
  'partnerDealers',
];
export const RANGE_FILTERS = ['price', 'power', 'modelYear', 'mileage'];
export const SINGLE_FILTERS = ['availableInMonths', 'usedInventoryType', 'vehicleType'];

export const ACCEPTABLE_URL_PARAMS = [
  'carline-group',
  'body-style',
  'carline',
  'price',
  'year',
  'power',
  'gearbox',
  'drivetrain',
  'fuel-type',
  'wheel-size',
  'colour',
  'interior',
  'trimline',
];

export const ACCEPTABLE_URL_PARAMS_TIER3 = [
  'modelFamily',
  'type',
  'body-style',
  'price',
  'year',
  'power',
  'mileage',
  'gearbox',
  'drivetrain',
  'fuel-type',
  'wheel-size',
  'colour',
  'interior',
  'trimline',
  'nonAudi',
  'otherMakes',
  'nonAudiModels',
  'availableInMonths',
  'usedInventoryType',
];

export const ALL_FILTERS_OPENED: ExposedFiltersTypes = {
  sortBy: true,
  partnerDealers: true,
  otherMakes: true,
  nonAudiModels: true,
  bodyType: true,
  modelFamily: true,
  trimLine: true,
  exteriorColor: true,
  interiorColor: true,
  fuelType: true,
  drivetrain: true,
  wheelSize: true,
  gearBox: true,
  mileage: true,
  price: true,
  power: true,
  modelYear: true,
};

export const ALL_FILTERS_CLOSED: ExposedFiltersTypes = {
  sortBy: false,
  partnerDealers: false,
  otherMakes: false,
  nonAudiModels: false,
  bodyType: false,
  modelFamily: false,
  trimLine: false,
  exteriorColor: false,
  interiorColor: false,
  fuelType: false,
  drivetrain: false,
  wheelSize: false,
  gearBox: false,
  mileage: false,
  price: false,
  power: false,
  modelYear: false,
};

export const DEFAULT_FILTER_POSITIONS: FiltersPositionTypes = {
  vehicleTypePosition: 1,
  listOfDealersPosition: 2,
  bodyTypePosition: 4,
  makeTypesPosition: 3,
  modelFamilyPosition: 5,
  modelYearPosition: 7,
  trimLinePosition: 6,
  pricePosition: 11,
  mileagePosition: 10,
  exteriorColorPosition: 8,
  interiorColorPosition: 9,
  fuelTypePosition: 12,
  driveTrainPosition: 13,
  wheelSizePosition: 14,
  gearboxPosition: 15,
  powerPosition: 16,
};

export const DEFAULT_FILTER_STATES: ExposedFiltersTypes = {
  bodyTypePanelState: true,
  makeTypePanelState: true,
  modelFamilyPanelState: true,
  modelYearPanelState: true,
  trimLinePanelState: true,
  pricePanelState: false,
  mileagePanelState: true,
  exteriorColorPanelState: true,
  interiorColorPanelState: false,
  fuelTypePanelState: false,
  driveTrainPanelState: false,
  wheelSizePanelState: false,
  gearboxPanelState: false,
  powerPanelState: false,
};
